export const app = 'app';
export const language = 'language';
export const translation = 'translation';
export const translationKeySearch = 'translationKey/Search';
export const translationKeySearchDropdown = 'translationKey/SearchDropdown';
export const translationKeyImages = 'translationImage';
export const translationVotes = 'translationvote';
export const translationReports = 'translation/Report';
export const translationsPerLangGraph = 'translation/Graph/TranslationsPerLanguage';
export const streamEmoteWithCaptcha = 'stream/EmoteWithCaptcha';
export const streamEmoteWhileLoggedIn = 'stream/LoggedInEmote';
export const patreon = 'patreon';
export const authUrl = 'Account/Login';